import { render, staticRenderFns } from "./PoliciesMain.vue?vue&type=template&id=4d2ec740"
import script from "./PoliciesMain.vue?vue&type=script&lang=js"
export * from "./PoliciesMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports